<template>
  <el-row class="mb-3" v-if="amReady">
    <div class="m-0 p-0 mb-5 border-bottom" v-if="formHeader">
      <h5>{{ this.getFormTitle }}</h5>
    </div>
    <div class="mb-2" v-else></div>

    <el-dialog  :visible.sync="ratesDocumentsDialog" title="" top="2vh" :append-to-body="true"  width="100%">
      <ratesDocuments editMode="false" v-if="ratesDocumentsDialog"></ratesDocuments>
    </el-dialog>

    <el-button type="primary" class="mb-4" @click="showRatesDocument">Show Rates Document</el-button>

    <h6 class="mb-5 text-secondary border p-3"><i class="el-icon-info"></i> Document should contains 2 columns
      <b>'rate'</b> and <b>'dialcode'</b> lowercase</h6>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-select-field
          :control="control"
          :field_span="16"
          :label_span="24"
          :options="vendorsList"
          :translateLabel="false"
          :translateLabels="false"
          :defaultValue="targetVendorId"
          :disabled="(targetVendorId)? true : false"
          @amUpdated="vendorChanged"
          field_mark="required"
          label="Vendor"
          name="vendor_id"
          rules="required"></dg-select-field>
    </el-col>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-select-field
          :control="control"
          :field_span="16"
          :label_span="24"
          :options="divisionsList"
          :translateLabel="false"
          :translateLabels="false"
          field_mark="required"
          :defaultValue="defaultDivision"
          :disabled="true"
          label="Division"
          name="division_id"
          rules="required"></dg-select-field>
    </el-col>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-file-upload
          :allowed-ext="['xlsx','xls']"
          :control="control"
          :field_span="24"
          :file-size-limit="12"
          :label_span="24"
          field_mark="required"
          label="rates_document"
          name="rate_document"
          rules="required"></dg-file-upload>
    </el-col>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-radio-field
          :control="control"
          :field_span="19"
          :label_span="24"
          :options="uploadOptions"
          :defaultValue="'add_new_only'"
          field_mark="required"
          label="upload_options"
          name="upload_options"
          rules="required"></dg-radio-field>
    </el-col>


    <el-col :span="24" class="mt-2 border-top">
      <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
        <dg-label-field class="error-field-validate-message" label="fields_do_not_match_the_required_criteria"
                        v-show="!this.validData"></dg-label-field>
      </el-col>
      <el-col :span="12" class="pt-3 text-right">
        <dg-confirm-button
            :loading="requestOn"
            :onConfirm="removeAction"
            :translate="false"
            class="mr-2"
            confirmButtonType="danger"
            fieldSize="mini"
            icon="el-icon-delete"
            popIcon="el-icon-delete"
            text="remove"
            title="sure to removing this record ?"
            type="danger"
            v-if="editMode"></dg-confirm-button>

        <dg-button :click="cancelEditable" class="mr-2" fieldSize="mini" icon="el-icon-close" text="cancel"
                   type="warning" v-if="editable && editMode"></dg-button>
        <dg-button :click="changeEditable" fieldSize="mini" icon="el-icon-edit" text="edit" type="success"
                   v-if="!editable && editMode"></dg-button>
        <dg-confirm-button
            :icon="actionButtonIcon"
            :loading="requestOn"
            :onConfirm="createModule"
            :text="actionButtonLabel"
            :translate="false"
            :type="actionButtonType"
            fieldSize="mini"
            v-if="editable"></dg-confirm-button>
      </el-col>
    </el-col>
  </el-row>
</template>

<script>
import Vue from 'vue'
import {mapState, mapActions} from 'vuex'
import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import module from './../index.js'
import {notify} from '@/system-services/notify.js'

export default {
  components: {
    ratesDocuments: () => import('./../rates-documents/page/View.vue'),
  },
  mixins: [fieldController],
  props: {
    afterUploadCallback: {
      required: false
    },
    targetVendorId: {
      required: false,
      default: null
    },
    formHeader: {
      required: false,
      default: false
    },
    formTitle: {
      required: false
    },
    editMode: {
      required: true,
      type: Boolean
    },
    onEditCallback: {
      required: false
    },
    onCreateCallback: {
      required: false
    },
  },
  data() {
    return {
      ratesDocumentsDialog: false,
      control: this,
      amReady: true,
      defaultDivision: null,
      uploadOptions: [
        {
          label: 'add_new_only',
          value: 'add_new_only',
          link_label: ''
        },
        {
          label: 'clean_previous_rates',
          value: 'clean_previous_rates',
          link_label: ''
        }
      ],
      requestOn: false,
      editable: !this.editMode,
      vendorsList: [],
      divisionsList: [],
      module: {
        ...module
      }
    }
  },
  beforeMount() {
    this.getVendorDropDownList().then(r => {
      this.vendorsList = r
    })

    this.getDivisionsDropDownList().then(r => {
      this.divisionsList = r
    })
  },
  computed: {
    ...mapState('ajaxManager', ['loadingRequests']),
    getFormTitle: function () {
      if (this.formTitle) {
        return this.formTitle
      } else {
        return ((!this.editMode) ? this.$ml.get('create') : this.$ml.get('edit')) + ' ' + this.module.info.caption
      }
    },
    actionButtonLabel: function () {
      if (!this.editMode) {
        return 'create';
      } else {
        return 'save'
      }
    },
    actionButtonIcon: function () {
      if (!this.editMode) {
        return 'el-icon-plus';
      } else {
        return 'el-icon-check'
      }
    },
    actionButtonType: function () {
      if (!this.validData) {
        return 'danger btn-small';
      } else {
        if (!this.editMode) {
          return 'primary app-bg-primary';
        } else {
          return 'primary'
        }
      }
    }
  },
  methods: {
    showRatesDocument () {
      this.ratesDocumentsDialog = true
    },
    vendorChanged(params) {
      let vendorId = params.field.field_value
      this.getVendorDivision({id: vendorId}).then((r) => {
        this.fields['division_id'].field.field_value = r.data
        this.fields['division_id'].field.validateMessage = ''
        this.fields['division_id'].field.updateValue()
      })
    },
    ...mapActions('voip-mrt-enterprise-vendor-api', {
      getVendorDropDownList: 'getDropDownList',
      getVendorDivision: 'getVendorDivision',
    }),
    ...mapActions('voip-mrt-enterprise-rate-division-api', {getDivisionsDropDownList: 'getDropDownList'}),
    cancelEditable() {
      let context = this
      this.amReady = false
      this.editable = false
      Vue.nextTick(() => {
        context.amReady = true
      })
    },
    changeEditable() {
      this.editable = !this.editable
    },
    removeAction(params) {
      let cxt = this
      this.requestOn = true
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: this.recordId}).then(response => {
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
          message: '',
          position: 'topRight',
          close: false,
          timeout: 1900,
          animateInside: true,
        });
        cxt.amReady = false
      })
    },
    createModule() {
      this.validateFields().then(result => {
        if (!result) return

        this.requestOn = true
        let context = this;
        let data = {data: this.dataModel};
        if (this.editMode) {
          data.id = this.dataToBind.id;
        }

        let api = (this.editMode) ? 'update' : 'importRates';
        this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
          this.amReady = false
          notify({
            type: 'success',
            title: this.$ml.get('successfully'),
            message: response.data,
            position: 'center',
            close: false,
            timeout: 4000,
            animateInside: true,
          });

          Vue.nextTick(() => {
            if (context.editMode) {
              if (context.onEditCallback) {
                context.onEditCallback(response.data)
              }
            } else {
              if (context.onCreateCallback) {
                context.onCreateCallback(response.data)
              }
            }
          })
          // this.$router.push({ name: this.module.stateName + '-module-list', params: {}}).then( response => {})
        }).catch(error => {
          this.amReady = false
          notify({
            type: 'success',
            title: 'successfully',
          });

          if (this.afterUploadCallback) {
            this.afterUploadCallback()
          }
         /* let message = JSON.parse(error.response.data.message)
          let status = message.status

          let title = 'failed'
          let type = 'error'
          if (status == 200) {
            title = 'successfully'
            type = 'success'
          }

          notify({
            type: type,
            title: title,
          });*/

          Vue.nextTick(() => {
            this.amReady = true
          })

        }).finally(() => {
          context.requestOn = false
          context.amReady = true
        })

      })
    }
  }
}
</script>
